<template>
  <div>
    <div class="input-container">
      <!-- Display Tags -->
      <span
        v-for="(email, index) in localEmails"
        :key="index"
        class="tag"
      >
        {{ email }}
        <button @click="removeEmail(index)" class="close-btn">x</button>
      </span>

      <!-- Input Field -->
      <input
        type="text"
        v-model="currentEmail"
        @keydown.enter.prevent="addEmail"
        @keydown.space.prevent="addEmail"
        @keydown.188.prevent="addEmail"
        placeholder="Type email and press Enter, Space, or Comma"
        class="email-input"
      />
    </div>
    <p class="helper-text" >Press Enter, Comma, or Space to commit PIC email</p>
  </div>
</template>

<script>
export default {
  props: {
    emails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentEmail: '', // Current input
      localEmails: [...this.emails], // Local copy of emails
    };
  },
  watch: {
    emails(newVal) {
      this.localEmails = [...newVal];
    },
  },
  methods: {
    addEmail() {
      const email = this.currentEmail.trim();
      if (email && this.isValidEmail(email) && !this.localEmails.includes(email)) {
        this.localEmails.push(email);
        this.$emit('update:emails', this.localEmails); // Emit updated list to parent
      }
      this.currentEmail = ''; // Clear input
    },
    removeEmail(index) {
      this.localEmails.splice(index, 1);
      this.$emit('update:emails', this.localEmails); // Emit updated list to parent
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
  },
};
</script>

<style scoped>
.input-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom: 1px solid #cccccc8f;
  padding: 5px;
  border-radius: 5px;
  min-height: 40px;
}

.tag {
  background-color: #2196f3;
  color: white;
  padding: 5px 10px;
  border-radius: 3px;
  margin: 2px;
  display: flex;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  margin-left: 5px;
  cursor: pointer;
  font-weight: bold;
}

.email-input {
  border: none;
  outline: none;
  flex: 1; /* Allow the input to take available space */
  min-width: 120px;
  padding: 5px;
  font-size: 14px;
}

.helper-text {
  margin-top: 5px;
  font-size: 12px;
  color: #888;
}
</style>
